import Vue from "vue";
import StepConsultation from "./index";
import axios from "axios";

new Vue({
  el: "#consultation-app",
  render: function (createElement) {
    const {
      followUpRequestId,
      questionnaire,
      bmiInformation,
      appTheme,
      analyticsProductName,
      analyticsCategory,
      analyticsQuantity,
      analyticsFilledIn,
      productCode,
      hostNameWithSchema,
      repeatQuestionUrl,
      productName,
      showStateQuestion,
      csrf,
      csrfHeader,
      states,
      skipSplashScreen,
      availableMeasurementSystems,
      productCategoryReference,
      companyName,
      showReOrderBanner,
    } = window.ConsultationProps;

    const submitUrl = `/api/consultations/${productCode}`;

    return createElement(StepConsultation, {
      props: {
        followUpRequestId,
        questionnaire,
        bmiInformation,
        appTheme,
        analyticsData: {
          "Treatment": analyticsCategory,
          "Medicine Name": analyticsProductName,
          "Quantity": analyticsQuantity,
        },
        submitUrl,
        analyticsFilledIn,
        productCode,
        hostNameWithSchema,
        reOrderInformation: {
          repeatQuestionUrl,
          productName,
        },
        showReOrderBanner,
        showStateQuestion,
        csrf,
        csrfHeader,
        states,
        skipSplashScreen,
        availableMeasurementSystems,
        productCategoryReference,
        companyName,
      },
    });
  },
});
